// UI Constants to reduce code duplication and improve maintainability

export const GRADIENT_VARIANTS = {
  blue: 'from-blue-50 to-blue-100/50 dark:from-blue-950/20 dark:to-blue-900/10',
  green: 'from-green-50 to-green-100/50 dark:from-green-950/20 dark:to-green-900/10',
  purple: 'from-purple-50 to-purple-100/50 dark:from-purple-950/20 dark:to-purple-900/10',
  slate: 'from-slate-50 to-slate-100/50 dark:from-slate-950/20 dark:to-slate-900/10',
  orange: 'from-orange-50 to-orange-100/50 dark:from-orange-950/20 dark:to-orange-900/10',
  red: 'from-red-50 to-red-100/50 dark:from-red-950/20 dark:to-red-900/10',
} as const;

export const ICON_COLORS = {
  blue: 'text-blue-600 dark:text-blue-400',
  green: 'text-green-600 dark:text-green-400',
  purple: 'text-purple-600 dark:text-purple-400',
  slate: 'text-slate-600 dark:text-slate-400',
  orange: 'text-orange-600 dark:text-orange-400',
  red: 'text-red-600 dark:text-red-400',
} as const;

export const TEXT_COLORS = {
  blue: 'text-blue-700 dark:text-blue-300',
  green: 'text-green-700 dark:text-green-300',
  purple: 'text-purple-700 dark:text-purple-300',
  slate: 'text-slate-700 dark:text-slate-300',
  orange: 'text-orange-700 dark:text-orange-300',
  red: 'text-red-700 dark:text-red-300',
} as const;

export const BG_COLORS = {
  blue: 'bg-blue-100 dark:bg-blue-900/30',
  green: 'bg-green-100 dark:bg-green-900/30',
  purple: 'bg-purple-100 dark:bg-purple-900/30',
  slate: 'bg-slate-100 dark:bg-slate-900/30',
  orange: 'bg-orange-100 dark:bg-orange-900/30',
  red: 'bg-red-100 dark:bg-red-900/30',
} as const;

export const SHADOW_VARIANTS = {
  sm: 'shadow-sm',
  default: 'shadow-lg hover:shadow-xl',
  lg: 'shadow-xl hover:shadow-2xl',
} as const;

export const TRANSITION_CLASSES = {
  default: 'transition-all duration-300',
  fast: 'transition-all duration-200',
  slow: 'transition-all duration-500',
} as const;

export type ColorVariant = keyof typeof GRADIENT_VARIANTS;